export type CommandHandler<T> = T extends Command<infer X> ? CommandHandler<X>
    : T extends any[] ? (...args: [...T]) => void
    : never;

export class Command<T extends unknown[] = []> {
    handler?: (...args: [...T]) => void;

    run(...args: [...T]) {
        if (this.handler) {
            this.handler(...args);
        }
    }
}
